import React, { useState, useEffect } from 'react';
import Navbar from '../layout/navbar/navbar';
import Footer from '../layout/footer/footer';
import './home.css';
import Shap from '../assets/images/bg-shap.svg';
import BeNatural from '../assets/images/be-natural.svg';
import { TabView, TabPanel } from 'primereact/tabview';
import ProductsItem from '../components/productsItem/products-items';
import CategoryList from '../components/categories/category';
import SliderWeb from '../components/slider/slider';
import QuestionComponent from '../components/questions/queation';
import useToastNotification from '../hooks/useToastNotification';
import BlogComponent from '../components/blogs/blogs';
import { Skeleton } from 'primereact/skeleton';
import Loader from '../components/loader/dotloader';
import { GetBanners, GetInfo, GetQuestions, GetProducts, GetLastProducts, GetBestProducts, GetListGroupKala, GetListPack, getGallery } from '../utils/api';
import DefultImg from '../assets/images/defult-img copy.svg'

// Icons
import ArrowLeft from '../assets/icons/arrow-left.svg';
import Clipboard from '../assets/icons/clipboard.svg';
import Timer from '../assets/icons/timer.svg';
import Convert from '../assets/icons/convert.svg';
import Headphone from '../assets/icons/headphone.svg';
import Post from '../assets/icons/post.svg';
import LeafBg from '../assets/images/leaf-bg.svg';

function Home() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [categoryActiveIndex, setCategoryActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [loadingCategory, setLoadingCategory] = useState(false);
  const [bannerHomeList, setBannerHomeList] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [bestProducts, setBestProducts] = useState([]);
  const [lastProducts, setLastProducts] = useState([]);
  const [infoData, setInfo] = useState([]);
  const [packs, setPacks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [gallery, setGalleries] = useState([]);
  const { showError, showSuccess } = useToastNotification();
  const [questionList, setQuestionList] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);


      const questionsData = await GetQuestions();
      setQuestionList(questionsData.data);

      const allProductData = await GetProducts();
      setAllProducts(allProductData.data);

      const bestProductData = await GetBestProducts();
      console.log(bestProductData.data)
      setBestProducts(bestProductData.data);

      const lastProductData = await GetLastProducts();
      setLastProducts(lastProductData.data);

      const CategoriesData = await GetListGroupKala();
      setCategories(CategoriesData.data);

      const packData = await GetListPack();
      setPacks(packData.data);

      const infoData = await GetInfo();
      setInfo(infoData.data);

      const galleryData = await getGallery();
      setGalleries(galleryData.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      showError('Error fetching data');
    } finally {
      setLoading(false);
    }
  };
  const fetchBanner = async () => {
    try {
      setLoading(true);
      const bannerData = await GetBanners();
      setBannerHomeList(bannerData.data);


    } catch (error) {
      console.error('Error fetching data:', error);
      showError('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    setTimeout(() => {
      fetchBanner()
    }, 1000);
  }, []);

  const handleTabClick = (index) => {
    setActiveIndex(index); // تغییر تب به صورت فوری
    setLoadingProduct(true);  // فعال کردن لودینگ
  };

  useEffect(() => {
    // وقتی activeIndex تغییر کرد، لودینگ محصولات را غیرفعال کن
    const timer = setTimeout(() => {
      setLoadingProduct(false);
    }, 800);  // زمان تأخیر دلخواه (مثلاً 500 میلی‌ثانیه)

    return () => clearTimeout(timer);  // پاک کردن تایمر
  }, [activeIndex]);  // وابسته به تغییرات activeIndex

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingCategory(false);
    }, 400);
    return () => clearTimeout(timer);
  }, [categoryActiveIndex]);
  function convertToPersianNumbers(input) {
    if (input) {

      const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }
  }
  return (
    <div>
      {loading && <Loader isLoading={loading} />}

      <div className="container mt-2 px-0">
        <SliderWeb bannerImg={bannerHomeList} />
      </div>

      {!loading && (
        <>
          {/* Products Section */}
          <section style={{ position: 'relative' }}>
            <img src={Shap} alt="background" style={{ position: 'absolute', right: '0', top: '-10em', zIndex: '-1' }} />
            <div className="tab-home">
              <div className="flex mb-2 tab-btns justify-content-center">
                <button
                  onClick={() => { setActiveIndex(0); setLoadingProduct(true); }}
                  className="btn rounded-64"
                  style={activeIndex !== 0 ? { backgroundColor: '#fff', border: '1px solid #00a14b', color: '#00a14b', height: 'auto' } : { backgroundColor: '#00a14b', color: '#fff', height: 'auto' }}
                >
                  همه محصولات
                </button>
                <button
                  onClick={() => { setActiveIndex(1); setLoadingProduct(true); }}
                  className="btn  rounded-64"
                  style={activeIndex !== 1 ? { backgroundColor: '#fff', border: '1px solid #00a14b', color: '#00a14b', height: 'auto', height: 'auto' } : { backgroundColor: '#00a14b', color: '#fff', height: 'auto' }}
                >
                  پر فروش ترین ها
                </button>
                <button
                  onClick={() => { setActiveIndex(2); setLoadingProduct(true); }}
                  className="btn   rounded-64"
                  style={activeIndex !== 2 ? { backgroundColor: '#fff', border: '1px solid #00a14b', color: '#00a14b', height: 'auto' } : { backgroundColor: '#00a14b', color: '#fff', height: 'auto' }}
                >
                  آخرین فروش ها
                </button>

              </div>

              {loadingProduct ? (
                <>

                  <div className="skeleton-wrapper py-4 container web-selekton gap-2 px-0">
                    {[...Array(5)].map((_, index) => (
                      <div className='product-item flex-1' >
                        <div className='product-img aspect-[4/4]'>
                          <Skeleton className='img-box img-product h-100' alt="Image 1" />
                        </div>
                        <div >
                          <div className='detail w-100'>
                            <Skeleton className='product-title' />
                            <Skeleton className='mt-2 number-font' />
                          </div>

                          <div >
                            <Skeleton height='40px' className='mt-3 btn btn-primary w-100 h-[48px]' />
                            {/* )} */}
                          </div>

                          <Skeleton className='f-10 mt-2' />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="skeleton-wrapper container d-flex gap-2 align-items-center justify-content-between mobile-selekton px-0">
                    {[...Array(1)].map((_, index) => (

                      <div className='product-item flex-1' >
                        <div className='product-img aspect-[4/4]'>
                          <Skeleton className='img-box img-product h-100' alt="Image 1" />
                        </div>
                        <div className='flex-1 mt-2'>
                          <div className='detail w-100 '>
                            <Skeleton className='product-title' />
                            <Skeleton className='mt-2 number-font' />
                          </div>

                          <div >
                            <Skeleton height='40px' className='mt-3 btn btn-primary w-100 h-[48px]' />
                            {/* )} */}
                          </div>

                          <Skeleton className='f-10 mt-2' />
                        </div>
                      </div>
                    ))}
                  </div>
                </>

              ) : (
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="container tab-contain px-0">
                  <TabPanel>
                    <ProductsItem productCat={activeIndex} productsData={allProducts} />
                  </TabPanel>
                  <TabPanel>
                    <ProductsItem productCat={activeIndex} productsData={bestProducts} />
                  </TabPanel>
                  <TabPanel>
                    <ProductsItem productCat={activeIndex} productsData={lastProducts} />
                  </TabPanel>
                </TabView>
              )}
            </div>
            <img src={BeNatural} className="web" alt="Be Natural" style={{ position: 'absolute', left: '0', bottom: '-2em' }} />
          </section>

          {/* Features Section */}
          <section className="feature-body pb-5 mt-6">
            <div className="container mt-5 text-center">
              <h4 className="title f-16 mx-auto">چرا طبیعی باش؟!</h4>
              <h2 className="mt-4 fw-700" style={{ color: '#00a14b' }}>در هر موقعیتی شیک ترین بسته های غذایی را از بن آیس بخواهید</h2>
              <div className="features row gx-4 gy-4 mt-5 ">
                {infoData.length && infoData.map((item, index) => (
                  <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column'> 
                     <div className="item  ">
                    <img src={item.Pic} className="mx-auto aspect-[3/3] " onError={(e) => {
                      e.target.onerror = null; // جلوگیری از لوپ بی‌نهایت
                      e.target.src = DefultImg;
                    }} alt="Free Shipping" width={80} />
                    <h5 className="f-18 fw-700 mt-4">{item.Onvan}</h5>
                    <h6 className="f-14 fw-400 mt-3" dangerouslySetInnerHTML={{ __html: item.Sharh }}></h6>
                  </div>
                    </div>
                
                ))}


              </div>
            </div>
          </section>

          {/* Categories Section */}
          <section style={{ position: 'relative' }}>
            <div className="tab-home category-tab">
              <div className="flex mb-2 justify-content-center" style={{ gap: '24px' }}>
                <button
                  onClick={() => { setCategoryActiveIndex(0); setLoadingCategory(true); }}
                  className="btn tab-category-btn rounded-16 "
                  style={categoryActiveIndex !== 0 ? { backgroundColor: '#fff' } : { backgroundColor: '#FF9C00', color: '#fff' }}
                >
                  دسته بندی ها
                </button>
                <button
                  onClick={() => { setCategoryActiveIndex(1); setLoadingCategory(true); }}
                  className="btn tab-category-btn"
                  style={categoryActiveIndex !== 1 ? { backgroundColor: '#fff' } : { backgroundColor: '#FF9C00', color: '#fff' }}
                >
                  پک های پذیرایی
                </button>
              </div>

              {loadingCategory ? (
                <div className="skeleton-wrapper py-4 pb-5 container d-flex align-items-center justify-content-between web-selekton gap-2 px-0">
                  {[...Array(5)].map((_, index) => (
                    <div className="d-flex items-center justify-center flex-column" key={index}>
                      <div className="category-img h-[190px]" style={{ width: '190px' }}>
                        <Skeleton className="img-box img-category h-100" alt="Category Image" />
                      </div>
                      <Skeleton className="mt-2" />
                    </div>
                  ))}
                </div>
              ) : (
                <TabView activeIndex={categoryActiveIndex} onTabChange={(e) => setCategoryActiveIndex(e.index)} className="container tab-contain category-list px-0">
                  <TabPanel>
                    <CategoryList type={categoryActiveIndex} categoriesList={categories} />
                  </TabPanel>
                  <TabPanel>
                    <CategoryList type={categoryActiveIndex} categoriesList={packs} />
                  </TabPanel>
                </TabView>
              )}
            </div>
          </section>

          {/* Blog Section */}
          <section className="container mt-6" style={{ position: 'relative' }}>
            <h4 className="title f-16 mx-auto mb-5">گالری تصاویر</h4>
            <BlogComponent galleryData={gallery} />
          </section>

          {/* Questions Section */}
          <section className="qs-section" style={{ position: 'relative' }}>
            <img src={LeafBg} className="web" alt="Leaf Background" style={{ position: 'absolute', right: '0', top: '3em' }} />
            <QuestionComponent questionsList={questionList} />
          </section>
        </>
      )}
    </div>
  );
}

export default Home;
